/* eslint-disable jsx-a11y/anchor-is-valid */
import moment from "moment";
import { IConsultaCard } from "./types";
import { Presencial, Teleconsulta } from "./components/ConsultaOptions";

const ConsultaCard = ({ appointment, isPastAppointment }: IConsultaCard) => {
  return (
    <>
      <div className="card p-3 mb-2">
        <div className="row align-items-center">
          <div className="col-4 col-md-1 col-lg-1 text-end border-end px-2">
            <p className="text-muted mb-0 lh-1 text-capitalize">
              {moment().day(appointment.scheduleTime.day).format("ddd")}
            </p>
            <p className="fw-bold h5 mb-0 lh-1">
              {moment(appointment.date).date()}
            </p>
            <p className="small mb-0 lh-1">
              {moment(appointment.date).format("MMM")}
            </p>
          </div>

          <div className="col-8 col-md-2 col-lg-1 text-center">
            <p className="fw-medium mb-0">{`${
              appointment.scheduleTime.initialTimeHours
            }:${String(appointment.scheduleTime.initialTimeMinutes).padStart(
              2,
              "0"
            )}`}</p>
          </div>

          <div className="col-12 col-md-4 col-lg-3 mt-3 mt-md-0 border-top border-md-top-0">
            <div className="row align-items-center justify-content-center pt-3 pt-md-0">
              <div className="col-4 text-end">
                <div className="img-wrap">
                  <img
                    alt={`${
                      appointment.specialistDoctor.gender === 0 ? "Dra." : "Dr."
                    } ${appointment.specialistDoctor.name}`}
                    src={
                      appointment.specialistDoctor.image
                        ? appointment.specialistDoctor.image
                        : appointment.specialistDoctor.gender === 0
                        ? "https://conectadoc.com.br/ImgMedico/Thumbs/ThumbFemale.jpg"
                        : "https://conectadoc.com.br/ImgMedico/Thumbs/ThumbMale.jpg"
                    }
                  />
                </div>
              </div>
              <div className="col-8 pl-0 text-left text-md-left">
                <h5 className="fw-medium mb-0">
                  {appointment.specialistDoctor.gender === 0 ? "Dra." : "Dr."}{" "}
                  {appointment.specialistDoctor.name}
                </h5>
              </div>
            </div>
          </div>

          {appointment.scheduleType === 0 ? (
            <Presencial
              address={appointment.address}
              isPastAppointment={isPastAppointment}
              appointment={appointment}
            />
          ) : (
            <Teleconsulta
              paymentStatus={appointment.paymentStatus}
              isPastAppointment={isPastAppointment}
              appointment={appointment}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default ConsultaCard;
